export const SET_DASHBOARD = 'SET_DASHBOARD'
export const SET_CLIENTREVIEW = 'SET_CLIENTREVIEW'
export const SET_CLIENTINSPECTIONS = 'SET_CLIENTINSPECTIONS'



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/types.js